function getButtons() {
    return [...document.querySelectorAll('.js_searchLayoutToggles__button')];
}

function toggleLayout(layout) {
    const container = document.querySelector('.js_vehicleCardsGrid');

    if (container) {
        if (layout == 'grid') {
            container.classList.remove('vehicleCardsGrid--isList');
            container.classList.add('vehicleCardsGrid--isGrid');
        }

        if (layout == 'list') {
            container.classList.remove('vehicleCardsGrid--isGrid');
            container.classList.add('vehicleCardsGrid--isList');
        }
    }
}

function toggleVehicle(vehicle, layout) {
    if (layout == 'grid') {
        vehicle.classList.remove('vehicleCard--horizontal');
    }

    if (layout == 'list') {
        vehicle.classList.add('vehicleCard--horizontal');
    }
}

function toggleVehicles(layout) {
    const vehicles = [...document.querySelectorAll('.js_vehicleCard')];

    vehicles.forEach(vehicle => toggleVehicle(vehicle, layout));
}

function toggleButtons(button) {
    const buttons = getButtons();

    button.classList.add('searchLayoutToggles__button--active');
    buttons.filter(btn => btn != button).forEach(btn => btn.classList.remove('searchLayoutToggles__button--active'));
}

async function setLayoutOnSession(layout) {
    const formData = new FormData()
    formData.append('search_layout', layout)

    try {
        const res = await fetch('/modules/Search/set_search_layout.php', {
            method: 'POST',
            headers: new Headers({
                'Accept': 'application/json'
            }),
            credentials: 'same-origin',
            body: formData
        })

        const body = await res.json()

        if (!res.ok) {
            return await Promise.reject(body);
        }
    } catch (e) {
        console.error(e)
    }
}

function handleClick(button) {
    const layout = button.getAttribute('data-layout');

    if (layout) {
        toggleButtons(button);
        toggleLayout(layout);
        toggleVehicles(layout);
        setLayoutOnSession(layout)
    }
}

export function initToggleLayout() {
    const buttons = getButtons();

    buttons.forEach(button => button.addEventListener('click', e => handleClick(button)));
}

$(document).ready(initToggleLayout);
